import { getFaceApproveList } from "@/services/all-api.js";
import axios from "axios";

function listTrans(obj) {
    const result = {
        data: obj.data.map((item, i) => ({
            num: obj.index * obj.size + i + 1,
            ...item
        })),
        total: obj.total,
        index: obj.index,
        size: obj.size
    };
    return result;
}
export default class dataApi {
    static firstGet() {
        const allObj = {
            index: 0,
            size: 20
        };

        function getAll() {
            return getFaceApproveList(allObj);
        }

        return axios
            .all([getAll()])
            .then(
                axios.spread(all => {
                    const obj = {
                        allData: listTrans(all)
                    };
                    return obj;
                })
            )
            .catch(error => {
                return Promise.reject(`获取数据失败:${JSON.stringify(error)}`);
            });
    }
    static pageSearchGetFunc(obj) {
        async function tempFunc() {
            try {
                let result = await getFaceApproveList(obj);
                return {
                    data: listTrans(result)
                };
            } catch (e) {
                console.log(e);
            }
        }
        return tempFunc();
    }
}

//在这里面做接口对象值转化翻译